<ng-container *ngIf="categoryId === 1">
  <div class="d-flex flex-column mb-2" style="margin-left: 2.8em; margin-right: 2em">
    <div class="d-flex flex-row justify-content-around mb-3" style="height: 373.5px; gap: 0.25em">
      <ng-container *ngFor="let image of product.additionalInfo?.images; let i = index">
        <ng-container *ngIf="i === 0">
          <div class="d-flex" style="height: auto; width: 100%">
            <picture class="w-100">
              <img [src]="image.thumbnail" style="width: 100%; height: 373.5px; object-fit: fill" alt="image_tour" />
            </picture>
          </div>
        </ng-container>
      </ng-container>
      <div class="d-flex flex-column" style="height: auto; width: 50%">
        <ng-container *ngFor="let image of product.additionalInfo?.images; let i = index">
          <ng-container *ngIf="i > 0 && i <= 2">
            <div *ngIf="i === 1" class="w-100 h-50">
              <picture>
                <img [src]="image.thumbnail" style="width: 100%; height: 184.5px; object-fit: fill" alt="image_tour" />
              </picture>
            </div>
            <div *ngIf="i === 2" class="w-100 h-50 mt-1" style="position: relative">
              <picture>
                <img [src]="image.thumbnail" style="width: 100%; height: 184.5px; object-fit: fill" alt="image_tour" />
              </picture>
              <button
                (click)="goTabPhotos()"
                type="button"
                class="px-4 py-2 rounded-pill d-flex align-items-center justify-content-center"
                style="border: none; background-color: #ececec; position: absolute; bottom: 1em; right: 2em"
              >
                <p class="mb-0" style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 9px; font-weight: 600">
                  + de {{ product.additionalInfo.images.length - 1 }} fotos
                </p>
              </button>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div class="mx-4 mt-1">
      <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 15px; font-weight: 600">Descripción</p>

      <ng-container *ngIf="hotelDescription !== ''">
        <p class="mb-4 hotel-description" style="margin-top: 20px; font-weight: 400">
          {{ hotelDescription }}
        </p>
      </ng-container>

      <ng-container *ngIf="hotelDescription === ''">
        <p class="mb-4 hotel-description" style="margin-top: 20px; font-weight: 400">N/A</p>
      </ng-container>

      <div class="d-flex justify-content-around align-items-start flex-row w-100 mt-4 mb-4" style="width: calc(100% - 180px)">
        <div class="d-flex w-100">
          <div
            *ngFor="let column of columnsInfoHotel; let i = index"
            class="d-flex flex-column me-3 w-100"
            [ngStyle]="{ 'margin-left': i > 0 ? '10px' : 0 }"
          >
            <div *ngFor="let info of column" class="mb-4 w-100" [ngStyle]="{ color: info?.value === 'N/A' ? '##4b4b4bff' : '' }">
              <div class="d-flex align-items-center" style="gap: 5px">
                <div>
                  <img *ngIf="info?.image !== ''" class="i-description" [src]="info?.image" alt="" />
                </div>
                <div>
                  <p class="mb-0 hotel-description-title" style="line-height: 1">{{ info?.title }}</p>
                  <p class="mb-0 hotel-description" style="line-height: 1">{{ info?.value }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex" style="border-bottom: 1px solid #6c6c6e; border-top: 1px solid #6c6c6e">
        <div class="py-4 w-100">
          <p class="mb-0 hotel-description-title" style="line-height: 1">Horario de check in</p>
          <p class="mb-0 hotel-description" style="line-height: 1">
            {{ product?.additionalInfo?.TimeInformation?.checkIn ? product?.additionalInfo?.TimeInformation?.checkIn + " hs." : "N/A" }}
          </p>
        </div>
        <div class="pl-3 py-4 w-100" style="border-left: 1px solid black">
          <p class="mb-0 hotel-description-title" style="line-height: 1">Horario de check out</p>
          <p class="mb-0 hotel-description" style="line-height: 1">
            {{ product?.additionalInfo?.TimeInformation?.checkOut ? product?.additionalInfo?.TimeInformation?.checkOut + " hs." : "N/A" }}
          </p>
        </div>
      </div>

      <div style="border-bottom: 1px solid #6c6c6e">
        <p class="hotel-description-title pt-4" style="font-size: 16px; margin-bottom: 15px">Requisitos de check-in</p>
        <div class="d-flex flex-column mb-4">
          <ng-container *ngFor="let requirement of arrRequirements">
            <div class="d-flex align-items-start pr-2" style="gap: 0.25em">
              <i class="bi bi-check-lg" style="-webkit-text-stroke: 1px; line-height: 1.2"></i>
              <p class="mb-0 hotel-description" style="line-height: 1.2; margin-top: 1px">{{ requirement?.description }}</p>
            </div>
          </ng-container>
        </div>
      </div>

      <div style="border-bottom: 1px solid #6c6c6e">
        <p class="hotel-description-title pt-4" style="font-size: 16px; margin-bottom: 15px">Como llegar</p>
        <div
          class="d-flex flex-row justify-content-between align-items-end mb-4"
          *ngFor="let itemToGet of [product?.additionalInfo?.howtoget]"
        >
          <div class="d-flex">
            <p class="ml-1 mb-0 hotel-description-title">{{ itemToGet.name }}</p>
          </div>
          <p class="mb-0 hotel-description-title">{{ itemToGet.address }}</p>
        </div>
      </div>

      <div class="pt-4" *ngIf="product?.additionalInfo?.atracttions.length > 0">
        <p class="hotel-description-title pt-4" style="font-size: 16px; margin-bottom: 15px">Atracciones</p>
        <div class="d-flex justify-content-between align-items-center px-4 py-3" style="border: 1px solid #6c6c6e">
          <p class="mb-0 hotel-description-title">Cantidad de atracciones: {{ product?.additionalInfo?.atracttions.length }}</p>
          <p
            class="mb-0 hotel-description-title"
            style="cursor: pointer"
            [ngStyle]="{ color: clientSetting?.clients_setting_global?.color_main_1 }"
            (click)="openAtracttions(product, categoryId)"
          >
            {{ revealAtracttions ? "Ocultar detalles" : "Ver detalles" }}
          </p>
        </div>

        <div *ngIf="revealAtracttions" class="mt-2 d-flex justify-content-between" style="gap: 1em">
          <div
            class="p-4 w-100"
            style="
              border: 1px solid #6c6c6e;
              border-bottom-left-radius: 6px;
              border-top-left-radius: 6px;
              overflow-y: auto;
              max-height: 500px;
            "
            [ngStyle]="{
              'scrollbar-width': 'thin',
              'scrollbar-color': (clientSetting?.clients_setting_global?.color_main_1 || '#6c6c6e') + ' #f0f0f0'
            }"
          >
            <div class="d-flex flex-column" style="gap: 1em">
              <ng-container *ngFor="let attraction of product?.additionalInfo?.atracttions; let i = index">
                <div class="d-flex" style="gap: 0.5em">
                  <div class="attraction-number">
                    {{ i + 1 }}
                  </div>
                  <div
                    class="attraction-card py-2 px-3 w-100"
                    style="border: 1px solid #6c6c6e"
                    [class.border-bottom]="i !== product?.additionalInfo?.atracttions?.length - 1"
                  >
                    <div class="attraction-info">
                      <div class="hotel-description-title" style="line-height: 1">{{ attraction?.name }}</div>
                    </div>

                    <div class="hotel-description d-flex align-items-center mt-3">
                      <img
                        src="{{
                          attraction?.description === 'a pie'
                            ? '../../../../../../assets/icons/search-result/hotel/A_PIE.svg'
                            : '../../../../../../assets/icons/search-result/hotel/MOVILIDAD.svg'
                        }}"
                        [ngStyle]="{ width: attraction?.description === 'a pie' ? '14px' : '18px' }"
                        alt=""
                      />
                      <span class="ml-2" style="font-weight: 600">{{ attraction?.description }}</span
                      >&nbsp;{{ attraction?.arrival_time }}
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="w-100">
            <app-map-view
              [coordinatesArr]="coordinatesArr"
              [clientSetting]="clientSetting"
              [currencies]="currencies"
              mapMode="general"
              [currencyAgency]="currencyAgency"
            >
            </app-map-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="categoryId === 6 && subCategoryId === 6">
  <div class="d-flex flex-column mb-2">
    <div class="d-flex flex-row justify-content-around" style="height: 323.5px; gap: 0.25em; margin-left: 2.8em; margin-right: 2em">
      <ng-container *ngFor="let image of product.additionalInfo?.images; let i = index">
        <ng-container *ngIf="i === 0">
          <div class="d-flex" style="height: auto; width: 100%">
            <picture class="w-100">
              <img [src]="image.thumbnail" style="width: 100%; height: 323.5px; object-fit: cover" alt="image_tour" />
            </picture>
          </div>
        </ng-container>
      </ng-container>
      <div class="d-flex flex-column" style="height: auto; width: 50%">
        <ng-container *ngFor="let image of product.additionalInfo?.images; let i = index">
          <ng-container *ngIf="i > 0 && i <= 2">
            <div *ngIf="i === 1" class="w-100 h-50">
              <picture>
                <img [src]="image.thumbnail" style="width: 100%; height: 159.5px; object-fit: cover" alt="image_tour" />
              </picture>
            </div>
            <div *ngIf="i === 2" class="w-100 h-50 mt-1" style="position: relative">
              <picture>
                <img [src]="image.thumbnail" style="width: 100%; height: 159.5px; object-fit: cover" alt="image_tour" />
              </picture>
              <button
                (click)="goTabPhotos()"
                type="button"
                class="px-4 py-2 rounded-pill d-flex align-items-center justify-content-center"
                style="border: none; background-color: #ececec; position: absolute; bottom: 1em; right: 2em"
              >
                <p class="mb-0" style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 9px; font-weight: 600">
                  + de {{ product.additionalInfo.images.length - 1 }} fotos
                </p>
              </button>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <p
      class="description-tour mb-0"
      style="
        font-family: &quot;Rubik&quot;, sans-serif;
        font-size: 15px;
        font-weight: 400;
        line-height: 1.5;
        margin-top: 30px;
        margin-left: 4.5em;
        margin-right: 5em;
        color: #272729;
      "
    >
      {{ descriptionComplete ? fullDescription : truncatedDescription }}

      <a
        *ngIf="product.description?.length > 300"
        (click)="moreDescription()"
        class="description-tour mb-0"
        style="
          font-family: &quot;Rubik&quot;, sans-serif;
          font-size: 15px;
          font-weight: 500;
          line-height: 1.1;
          margin-top: 30px;
          color: #272729;
          cursor: pointer;
        "
      >
        {{ descriptionComplete ? "...menos" : "...más" }}
      </a>
    </p>

    <div style="margin-left: 2.8em; margin-right: 2em; margin-top: 50px;">
      <p style="font-family: &quot;Poppins&quot;, serif; font-size: 19px; font-weight: 600; padding-left: 1.2em">Información general</p>

      <div class="d-flex flex-column justify-content-center" style="width: 100%; height: 85px;">
        <div class="d-flex align-items-center" style="padding-left: 1.2em">
          <img src="../../../../../assets/icons/itinerary/calendar_13937514.svg" width="26px" height="26px" alt="" />
          <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 14px; font-weight: 600; margin-left: 0.15em">
            Cancelación {{ product?.additionalInfo?.tours?.options[0]?.rateClass === "R" ? "gratuita" : "" }}
          </p>
        </div>
        <p
          class="mb-0"
          style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 13px; font-weight: 400; line-height: 1; margin-left: 3.75em"
        >
          <span *ngIf="product?.additionalInfo?.tours?.options[0]?.rateClass === 'R'">
            Cancela gratis hasta {{ product?.additionalInfo?.tours?.options[0]?.cancellation_policy[0]?.dateFrom | date: "dd/MM/yyyy" }} y
            recibe un reembolso completo
          </span>
          <span *ngIf="product?.additionalInfo?.tours?.options[0]?.rateClass === 'NR'"> Cancelación con 100% de cargo </span>
        </p>
      </div>

      <div class="d-flex" style="border-top: 1px solid #b4b4b4; border-bottom: 1px solid #b4b4b4; height: 85px">
        <div class="d-flex flex-column justify-content-center" style="width: 100%; border-right: 1px solid #b4b4b4">
          <div class="d-flex align-items-center" style="padding-left: 1.2em">
            <img src="../../../../../assets/icons/search-result/tiempo_uso.svg" width="24px" alt="" />
            <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 14px; font-weight: 600; margin-left: 0.25em">
              Duración {{ getDurations(product?.additionalInfo?.tours?.options) }}
            </p>
          </div>
          <p
            *ngIf="periodsActivities(product?.additionalInfo?.tours?.options) !== ''"
            class="mb-0"
            style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 13px; font-weight: 400; line-height: 1; margin-left: 3.6em"
          >
            Suele estar disponible por la {{ periodsActivities(product?.additionalInfo?.tours?.options) }}
          </p>
          <p
            *ngIf="periodsActivities(product?.additionalInfo?.tours?.options) === ''"
            class="mb-0"
            style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 13px; font-weight: 400; line-height: 1; margin-left: 3.6em"
          >
            <span
              *ngIf="
                product?.scheduling &&
                product?.scheduling &&
                product?.scheduling.length > 0 &&
                product?.scheduling[0]?.opened &&
                product?.scheduling[0]?.opened.length > 0
              "
            >
              Abierto desde {{ product?.scheduling[0].opened[0].openingTime }} hs. hasta
              {{ product?.scheduling[0].opened[0].closeTime }} hs.
            </span>
            <span *ngIf="product?.scheduling.length === 0"> Suele estar abierto todo el día </span>
          </p>
        </div>
        <div class="d-flex flex-column justify-content-center ml-3" style="width: 100%">
          <div class="d-flex align-items-center">
            <img src="../../../../../assets/icons/search-result/tour/idioma.svg" width="23px" alt="" />
            <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 14px; font-weight: 600; margin-left: 0.5em">
              Idioma
            </p>
          </div>

          <p
            class="mb-0"
            style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 13px; font-weight: 400; line-height: 1; margin-left: 2.4em"
          >
            La actividad se realiza {{ getGuideAmenity(product?.additionalInfo?.tours?.amenities.included) }}
            <span style="text-transform: lowercase">{{ getLanguages(product?.additionalInfo?.tours?.options) }}</span>
          </p>
        </div>
      </div>

      <div class="d-flex flex-column justify-content-center" style="margin-bottom: 30px; height: 85px;" [ngStyle]="{ 'border-bottom': product?.comments?.averageStars > 0 ? 'none' : '1px solid #b4b4b4'}">
        <div class="d-flex align-items-center" style="padding-left: 1.2em">
          <img src="../../../../../assets/icons/search-result/tour/gps.svg" width="21px" alt="" />
          <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 14px; font-weight: 600; margin-left: 0.5em">
            Ubicación
          </p>
        </div>
        <p
          class="mb-0"
          style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 13px; font-weight: 400; line-height: 1; margin-left: 3.7em"
        >
          {{ product?.additionalInfo?.location ? product?.additionalInfo?.location + ", " + payload[0]?.city : payload[0]?.city }}
        </p>
      </div>

      <div *ngIf="product?.additionalInfo?.routes && product?.additionalInfo?.routes.length > 0">
        <div class="d-flex flex-column mt-4">
          <div style="width: 30%">
            <p style="font-family: &quot;Poppins&quot;, serif; font-size: 19px; font-weight: 600; padding-left: 1.2em">Rutas</p>
          </div>
          <div class="d-flex flex-column mb-2" style="width: 100%">
            <ng-container *ngFor="let route of product?.additionalInfo?.routes; let routeIndex = index">
              <div
                class="d-flex justify-content-between align-items-center"
                style="padding: 14px 10px 14px 22px; border: 1px solid #ececec; margin-bottom: 10px;"
              >
                <p class="mb-0 vehicle-middle-description" style="font-weight: 500; line-height: 1; font-size: 13px !important">
                  {{ route.description }}: {{ route.duration }}
                </p>
                <button
                  type="button"
                  style="
                    font-family: 'Poppins', sans-serif;
                    font-size: 13px;
                    font-weight: 500;
                    border: none;
                    background-color: transparent;
                  "
                  [ngStyle]="{ color: clientSetting?.clients_setting_global?.color_main_1 }"
                  (click)="toggleRoute(product?.additionalInfo?.routes, routeIndex)"
                >
                  {{ selectedRouteIndex === routeIndex ? "Ocultar" : "Ver" }} detalle
                </button>
              </div>
            </ng-container>
          </div>
        </div>

        <div style="margin-bottom: 35px;" *ngIf="stopsRoute && stopsRoute.length > 0">
          <div class="d-flex p-3" style="gap: 1em; border: 1px solid #ececec">
            <div class="route-timeline" style="width: 50%; height: fit-content">
              <div *ngFor="let stop of stopsRoute; let j = index" class="timeline-stop">
                <div
                  class="stop-circle d-flex justify-content-center align-items-center"
                  style="border: 2px solid #000000; width: 35px !important; height: 35px !important"
                  [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_1 }"
                >
                  <span class="stop-order" style="color: #000000; font-size: 14px !important">
                    {{ stop.order }}
                  </span>
                </div>

                <div
                  class="stop-info"
                  (click)="selectStop(stop)"
                  style="cursor: pointer; border-radius: 5px; padding: 10px !important"
                  [ngStyle]="getStopCircleStyles(stop)"
                >
                  <span
                    *ngIf="stop?.description"
                    class="stop-description mb-1"
                    style="font-family: &quot;Rubik&quot; !important; font-size: 13px; font-weight: 600 !important"
                    >&nbsp;{{ stop.description }}</span
                  >
                  <span style="font-family: &quot;Rubik&quot;; font-size: 12px; line-height: 1.3">&nbsp;Hora: 8:40 hs. - 9:05 hs.</span>
                  <span
                    *ngIf="stop?.duration_hours && stop?.duration_minutes"
                    class="stop-description"
                    style="font-family: &quot;Rubik&quot;; font-size: 12px"
                    >&nbsp;Duración: {{ stop?.duration_hours }}:{{ stop?.duration_minutes }} hs.</span
                  >
                  <span class="stop-city mt-1" style="font-family: &quot;Poppins&quot;; font-size: 9px"></span>
                </div>
              </div>
            </div>

            <div style="width: 100%">
              <app-map-view
                [coordinatesArr]="stopsRoute"
                [coordinatesSelected]="coordinatesSelected"
                mapMode="route"
                [routeColor]="clientSetting?.clients_setting_global?.color_main_1"
              >
              </app-map-view>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Opiniones -->
  <div *ngIf="product?.comments?.averageStars > 0" class="d-flex mt-4 pt-5 pb-4" style="background-color: #ececec; padding-left: 3.5em; padding-right: 3.5em; margin-bottom: 25px;">
    <div class="d-flex flex-column" style="width: 35%">
      <div>
        <p class="mb-2" style="font-family: 'Poppins', serif; font-size: 19px; font-weight: 600; line-height: 1">Opiniones</p>
        <p class="mb-2" style="font-family: 'Poppins', serif; font-size: 14px; font-weight: 600; line-height: 1">
          Valoración general
        </p>
      </div>
      <div class="d-flex align-items-center" style="gap: 10px;">
        <ng-container *ngFor="let icon of iconsArr(); let i = index; let last = last">
          <div style="margin-top: 8px; margin-bottom: 15px;" [ngStyle]="{
            'background-color': i < product?.comments?.averageStars ? clientSetting?.clients_setting_global?.color_main_1 : 'transparent',
            'margin-left': i > 0 ? '2px' : '',
            width: '28px',
            height: '28px',
            'border-radius': '50%',
            position: 'relative',
            'z-index': 1,
            display: 'flex',
            'align-items': 'center',
            'justify-content': 'center'
          }">
            <img [src]="getIconsComments(i)" style="width: 30px;transform: scale(1.2)" alt="">
          </div>
        </ng-container>
      </div>
      <p class="mb-2" style="font-family: 'Poppins', serif; font-size: 30px; font-weight: 600; line-height: 1.2">4 / 5</p>
    </div>

    <div class="d-flex flex-column pr-5" style="width: 60%">
      <div style="height: 42px"></div>
      <!-- Guia -->
      <div class="row align-items-center justify-content-between mb-4">
        <div class="col-4">
          <p class="mb-0" style="font-family: 'Poppins', serif; font-size: 14px; font-weight: 600; line-height: 1.2">Guía</p>
        </div>

        <div class="col-6">
          <div style="width: 100%; height: 10px; background-color: #000000; overflow: hidden">
            <div style="width: 92%; height: 100%;" [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_1 }"></div>
          </div>
        </div>

        <div class="col-2">
          <div class="d-flex align-items-center" style="gap: 0.5em">
            <p class="mb-0" style="font-family: 'Poppins', serif; font-size: 12px; font-weight: 600; line-height: 1.2">4 / 5</p>
          </div>
        </div>
      </div>

      <!-- Transporte -->
      <div class="row align-items-center justify-content-between mb-4">
        <div class="col-4">
          <p class="mb-0" style="font-family: 'Poppins', serif; font-size: 14px; font-weight: 600; line-height: 1.2">Transporte</p>
        </div>

        <div class="col-6">
          <div style="width: 100%; height: 10px; background-color: #000000; overflow: hidden">
            <div style="width: 80%; height: 100%;" [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_1 }"></div>
          </div>
        </div>

        <div class="col-2">
          <div class="d-flex align-items-center" style="gap: 0.5em">
            <p class="mb-0" style="font-family: 'Poppins', serif; font-size: 12px; font-weight: 600; line-height: 1.5">4 / 5</p>
          </div>
        </div>
      </div>

      <!-- Calidad - Precio -->
      <div class="row align-items-center justify-content-between mb-4">
        <div class="col-4">
          <p class="mb-0" style="font-family: 'Poppins', serif; font-size: 14px; font-weight: 600; line-height: 1.2">Calidad - precio</p>
        </div>

        <div class="col-6">
          <div style="width: 100%; height: 10px; background-color: #000000; overflow: hidden">
            <div style="width: 98%; height: 100%;" [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_1 }"></div>
          </div>
        </div>

        <div class="col-2">
          <div class="d-flex align-items-center" style="gap: 0.5em">
            <p class="mb-0" style="font-family: 'Poppins', serif; font-size: 12px; font-weight: 600; line-height: 1.5">4 / 5</p>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- Extra Information - Experience -->
  <div *ngIf="(product?.additionalInfo?.tours?.amenities?.notIncluded &&  product?.additionalInfo?.tours?.amenities?.notIncluded?.length > 0) || (product?.additionalInfo?.general_info && product?.additionalInfo?.general_info.length > 0) || (product?.additionalInfo?.tours?.amenities?.included && product?.additionalInfo?.tours?.amenities?.included.length > 0)">
    <div
      *ngIf="product?.additionalInfo?.general_info && product?.additionalInfo?.general_info.length > 0"
      class="d-flex mt-4"
      style="border-bottom: 1px solid #ececec; margin-left: 2.8em; margin-right: 2em; padding: 20px 0px;"
    >
      <div style="width: 20%">
        <p class="mb-2 ml-3" style="font-family: &quot;Poppins&quot;, serif; font-size: 19px; font-weight: 600">¿Qué haras?</p>
      </div>
      <div style="width: 100%; padding-top: 5px;">
        <ul>
          <ng-container *ngFor="let info of product?.additionalInfo?.general_info">
            <li>
              <p class="mb-0 vehicle-middle-description" style="font-weight: 400; line-height: 22px; font-size: 14px; font-family: 'Rubik';">{{ info.info }}</p>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>

    <!-- Description -->
    <div
      *ngIf="product?.additionalInfo?.startingPointDescription"
      class="d-flex mt-2"
      style="border-bottom: 1px solid #ececec; margin-left: 2.8em; margin-right: 2em; padding: 20px 0px;"
    >
      <div style="width: 27%">
        <p class="mb-2 ml-3" style="font-family: &quot;Poppins&quot;, serif; font-size: 19px; font-weight: 600">Descripción</p>
      </div>
      <div style="width: 100%; padding-top: 5px;">
        <p class="mb-0 vehicle-middle-description" style="font-weight: 400; line-height:22px; font-size: 14px; font-family: 'Rubik';">{{ product?.additionalInfo?.startingPointDescription }}</p>
      </div>
    </div>

    <!-- Included -->
    <div
      *ngIf="product?.additionalInfo?.tours?.amenities?.included && product?.additionalInfo?.tours?.amenities?.included.length > 0"
      class="d-flex mt-2"
      style="border-bottom: 1px solid #ececec; margin-left: 2.8em; margin-right: 2em; padding: 20px 0px;"
    >
      <div style="width: 20%">
        <p class="mb-2 ml-3" style="font-family: &quot;Poppins&quot;, serif; font-size: 19px; font-weight: 600">Incluye</p>
      </div>
      <div style="width: 100%; padding-top: 5px;">
        <ul style="list-style: none;">
          <ng-container *ngFor="let amenity of product?.additionalInfo?.tours?.amenities?.included">
            <li style="margin-bottom: 5px;">
              <p class="mb-0 vehicle-middle-description" style="font-weight: 400; line-height:22px; font-size: 14px; font-family: 'Rubik';">{{ amenity.description }}</p>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>

    <!-- Not Included -->
    <div
      *ngIf="product?.additionalInfo?.tours?.amenities?.notIncluded &&  product?.additionalInfo?.tours?.amenities?.notIncluded?.length > 0"
      class="d-flex mt-2" style="margin-left:2.8em;margin-right:2em; padding: 20px 0px;"
    >
      <div style="width: 20%;">
        <p class="mb-2 ml-3" style="font-family: 'Poppins', serif; font-size: 19px; font-weight: 600;" >No Incluye</p>
        </div>
      <div style="width: 100%; padding-top: 5px;">
        <ul style="list-style: none;">
          <ng-container *ngFor="let amenity of product?.additionalInfo?.tours?.amenities?.notIncluded">
            <li style="margin-bottom: 5px;"> <p class="mb-0 vehicle-middle-description" style="font-weight: 400; line-height:22px; font-size: 14px; font-family: 'Rubik';">{{amenity.description}}</p></li>
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="categoryId === 6 && subCategoryId === 9">
  <div class="d-flex flex-column mb-2" style="margin-left: 2.8em; margin-right: 2em">
    <div class="d-flex flex-row justify-content-around" style="height: 350px; gap: 0.25em">
      <ng-container *ngFor="let image of product.additionalInfo?.images; let i = index">
        <ng-container *ngIf="i === 0">
          <div class="d-flex" style="height: auto; width: 100%">
            <picture class="w-100">
              <img [src]="image.thumbnail" style="width: 100%; height: 100%; object-fit: cover" alt="image_tour" />
            </picture>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <p class="description-tour px-3 mt-3">
      {{ product.description && descriptionComplete ? product.description : (product.description | truncate: 300 : "  ") }}
      <a
        (click)="moreDescription()"
        style="cursor: pointer"
        class="more"
        [ngStyle]="{ color: clientSetting?.clients_setting_global?.color_main_1 }"
        >...más</a
      >
    </p>
  </div>
</ng-container>
